<template>
  <div class="web-footer">
    <div class="web-bottom ">
      <ul>
        <li>
          <router-link to="/index" style="margin-right: 12px">首页</router-link>|
        </li>
        <li>
<!--          <router-link to="/experience" style="margin-right: 12px">体验</router-link>|-->
        </li>
        <li>
          <router-link to="/privacy" style="margin-right: 12px">隐私政策</router-link>|
        </li>
        <li>
          <router-link to="/terms">用户服务协议</router-link>
        </li>
        <!--        <li>-->
        <!--          <router-link to="/about/company">关于勇往</router-link>-->
        <!--        </li>-->
        <li>
          <!--<router-link to="/experience">产品体验</router-link>-->
        </li>
        <!--        <li>-->
        <!--          <a href="https://www.zhipin.com/gongsir/cce28d4330c3a94e33193927.html?ka=company-jobs">加入我们</a>-->
        <!--        </li>-->
        <!--        <li>-->
        <!--          <router-link to="/support">技术支持</router-link>-->
        <!--        </li>-->
        <!--        <li>-->
        <!--          <router-link to="/cooperation">联系我们</router-link>-->
        <!--        </li>-->
      </ul>
      <div class="copy">
        <div>
          <a href="http://www.beian.miit.gov.cn">苏ICP备20003914号</a>
          |
          小贝（南通）信息科技有限公司.All rights reserved.
        </div>
        <!--        <div>联系微信：tappop</div>-->
        <!--        <div>服务信箱：bryan@yongwangkeji.cn</div>-->
      </div>

    </div>

  </div>
</template>

<script>

  export default {
    name: "yw_footer",
    data() {
      return {
        localUrl: window.location.href,
        recordNum: 17025202, //备案号
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/yw_footer.vue